/** @jsx jsx */

import { css, jsx } from '@emotion/core';
import { addScormResponseAction } from 'actions/addScormResponseAction';
import { updateScoreAction } from 'actions/updateScoreAction';
import CorrectAnswersWidget from 'components/Editor/EditMultichoiceImage/CorrectAnswersWidget';
import SelectOptionAddRemoveWidget from 'components/Editor/EditSelectOptions/SelectOptionAddRemoveWidget';
import Feedback from 'components/lib/Feedback';
import React, {
  Fragment as _,
  createContext,
  ReactElement,
  useContext,
  useEffect,
  useRef,
  cloneElement,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useScoringQuizzes } from 'services/apiHelpers/useScoringQuizzes';
import { getScore, setScore } from 'services/scoring';
import { unlockInteraction } from 'services/unlockInteraction';
import { State } from 'store/store';
import { interactionContext as _interactionContext } from './interactionContext';
import getBlockById from 'services/apiHelpers/getBlockById';
import Modal from 'components/UI/Modal';
import { ShowMultichoiceMediaFeedback } from 'components/Editor/EditMultichoiceImage/EditMultichoiceImage';
import pubSub from 'services/pubSub';
import { findByKeyVal_V2 } from 'services/findByKeyVal';

const findChildByType = (type, parent) => {
  let result;
  const children = parent?.props?.children;

  if (Array.isArray(children)) {
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];
      // console.log(type, child?.props?.type);
      if (!result && child?.props?.type === type) {
        // console.log(type, child?.props?.type);
        result = child;
        break;
      }

      if (Array.isArray(child?.props?.children)) {
        findChildByType(type, child);
      }
    }
  }

  return result;
};

export type TMultichoiceImageContextValue = {
  selected: number[];
  setSelected: (index: number) => void;
  isLive: boolean;
  isResolved: boolean;
  onSubmit: () => void;
};

type Result = 'correct' | 'incorrect' | 'attempt' | undefined;

export const MultichoiceImageContext = createContext({});

const MultichoiceImage = props => {
  const interactionContext = useContext(_interactionContext);
  const { defaultFeedback } = interactionContext;

  // console.log(getBlockById(defaultFeedback.id));

  //
  const {
    correctOptions,
    numberOfAttempts = 2,
    showAttemptNumber = true,
    navigationBehaviour = {
      correct: false,
      incorrect: false,
    },
    useUniqueOptionFeedback,
    useMediaInFeedback = true,
    showCorrectAnswer,
  } = interactionContext.props;

  const { children } = props;

  const [media, answers, submitBtn] = children;
  // console.log(answers);

  const [selected, setSelected] = useState<number[]>([]);
  const [isResolved, setIsResolved] = useState<boolean>(false);
  const [isCorrect, setIsCorrect] = useState<boolean>(false);
  const [result, setResult] = useState<Result>(undefined);
  // const [attempt, setAttempt] = useState<number>(1);
  const [showFeedback, setShowFeedback] = useState<boolean>(false);

  const attempt = useRef<number>(0);

  const isLive: boolean = !!selected.length;

  // console.log({
  //   selected,
  //   isLive,
  //   isResolved,
  //   attempt: attempt.current,
  //   numberOfAttempts,
  //   showAttemptNumber,
  //   result,
  // });

  let feedback = defaultFeedback;

  if (correctOptions.length === 1 && useUniqueOptionFeedback) {
    // const found = findChildByType

    // const findChildByType = (type, parent) => {
    //   const children = parent?.props?.children;
    //   if (children && Array.isArray(children)) {
    //     const found = children.find(child => {
    //       if (child?.props?.type === type) {
    //         // found = child;
    //         return child;
    //       }

    //       if (Array.isArray(child?.props?.children)) {
    //         findChildByType(type, child);
    //       }
    //     });

    //     console.log({ found });
    //   }
    // };

    // console.log(findChildByType('Feedback', answers))
    feedback = findChildByType(
      'Feedback',
      answers.props.children[parseInt(correctOptions, 10)]
    );

    // console.log({ found });
  }

  console.log(feedback);

  // if (isResolved) {
  //   if (isCorrect) {
  //     feedback = defaultFeedback.props.children[0];
  //   }
  // }

  // console.log(defaultFeedback, feedback);

  useEffect(() => {
    unlockInteraction(interactionContext.id);
  }, [isResolved]);

  useEffect(() => {
    if (!window.dev()) {
      return;
    }

    pubSub.subscribe(
      `${ShowMultichoiceMediaFeedback}${interactionContext.id}`,
      ({ result }) => {
        setResult(result);
        setShowFeedback(true);
      }
    );
  }, []);

  return (
    <MultichoiceImageContext.Provider
      value={
        {
          selected,
          setSelected(index) {
            setSelected(selected => {
              const $ = [...selected];

              if ($.includes(index)) {
                console.log('remove', index);
                $.splice($.indexOf(index), 1);
              } else {
                console.log('add', index);
                $.push(index);
              }

              console.log($.sort());
              return $.sort();
            });
          },
          onSubmit() {
            const isCorrect = selected.sort().join(',') === correctOptions;

            let result: Result = isCorrect ? 'correct' : 'incorrect';

            attempt.current += 1;
            if (attempt.current < numberOfAttempts && result !== 'correct') {
              result = 'attempt';
            }

            setResult(result);

            if (['correct', 'incorrect'].includes(result)) {
              setIsResolved(true);
            }

            setShowFeedback(true);
          },
          isLive,
          isResolved,
        } as TMultichoiceImageContextValue
      }
    >
      <div
        style={{
          display: 'flex',
          flex: 0,
          flexWrap: 'wrap',
          justifyContent: 'space-around',
          // alignItems: 'center',
        }}
      >
        {answers.props.children.map((answer, index) => {
          return cloneElement(answer, { index: index + 1 });
        })}
      </div>
      <div
        style={{
          margin: '20px 0 0 0',
        }}
      >
        {/* {cloneElement(submitBtn, {
          enabled: selected.length,
          onSubmit() {
            console.log('submitted !!!');
          },
        })} */}
        {submitBtn}
      </div>

      {/* {feedback && <Modal onClose={() => {}}>{feedback}</Modal>} */}
      {showFeedback &&
        feedback &&
        React.cloneElement(feedback, {
          result,
          showAttemptNumber,
          attempt: attempt.current,
          numberOfAttempts,
          navigationBehaviour,
          onClose() {
            setShowFeedback(false);
          },
          useMediaInFeedback,
        })}
    </MultichoiceImageContext.Provider>
  );
};

export default MultichoiceImage;
